import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import { CDN_URL } from '../../../constants';

const Container = styled.div`
  border-radius: 50%;
  background-color: ${props => props.theme.palette.darkgray3};
  color: ${props => props.theme.palette.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 500;
  ${props =>
    props.size === 'xs'
      ? css`
          width: 32px;
          height: 32px;
          font-size: ${props => props.theme.fontSize['16']};
          line-height: 130%;
        `
      : props.size === 'sm'
      ? css`
          width: 54px;
          height: 54px;
          font-size: ${props => props.theme.fontSize['24']};
          line-height: 150%;
        `
      : css`
          width: 180px;
          height: 180px;
          font-size: ${props => props.theme.fontSize['80']};
          line-height: 130%;
        `};
  ${props =>
    props.src &&
    css`
      background-image: url(${props => props.src});
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    `};
`;

const Avatar = forwardRef(({ size, alt, src, ...other }, ref) => {
  const _alt = alt ? alt.substring(0, 1).toUpperCase() : '';
  return (
    // <Container size={size} src={src || ''} {...other} ref={ref}>
    <Container size={size} src={src ? `${CDN_URL}/avatar/${src}` : ''} {...other} ref={ref}>
      {!src && _alt}
    </Container>
  );
});

Avatar.defaultProps = {
  size: 'md',
  alt: '',
};

Avatar.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  alt: PropTypes.string.isRequired,
  src: PropTypes.string,
};

export default Avatar;
